<template lang="pug">
    .container
        .main
            .intro_box
                .intro_item
                    .intro_cover
                        img(class="intro_img" src="../assets/img/logo.jpg")
                    h4.intro_title.align-center 天乙的意義
                    p.intro_txt 天乙是貴人之星，是對自己有大幫助的人，命中遇之能逢凶化吉。這也是公司經營的信念，易經命理運用了上古世紀的仙人的智慧，照見人生的命運帶給我們生命的啟示，知命給我們有機會改變命運的軌跡，更提早為自己規劃命運的未來，不再讓命運的曲折，磨難我們的心，讓智慧的光芒照見心中的適合道路，指引著未來方向。
                    p.intro_txt 我們認為買商品不單單只是為了產品而已，有主要兩個目的：
                    ul.intro_list
                        li 1. 解決遇到的問題
                        li 2. 滿足某種心理
                    p.intro_txt 我們希望你過得好，因此我們先成為最好的，然後幫助你成為更美麗的自己。
                    p.intro_txt 一切的努力，都是為了將產品特點跟你們綁在一起。與你有關的，是你需要的，
                    p.intro_txt 是你現在就該購買的，我們亦盡量滿足於你。
                .intro_item
                    .intro_cover
                        img(class="intro_img" src="../assets/img/phone_calc.jpg")
                    h5.intro_title 業務員對陌生客戶最佳的特性分析
                    ol.intro_list_ol
                        li 五行與十神(直條圖)特性解說。
                        li 人格五特質(雷達圖)特性解說。
                        li 本手機特性解說。
                        li 九宮：本命、父(上司)、母(下屬)、配偶、子女、朋友、事業、財庫、健康各項解說。
                .intro_item
                    .intro_cover
                        img(class="intro_img" src="../assets/img/name_calc.jpg")
                    h5.intro_title 從姓名與年次就可判斷流年吉凶
                    ol.intro_list_ol
                        li 姓名之基本盤
                        li 三才與天運吉凶
                        li 流年九宮觀看流年運勢解說和卦意判斷
                        li 流月九宮觀看流月運勢解說和卦意判斷
                        li 流日九宮觀看流日運勢解說和卦意判斷
                .intro_item
                    .intro_cover
                        img(class="intro_img" src="../assets/img/horoscope.jpg")
                    h5.intro_title 只要手機在手，隨時可斷吉凶與建議
                    ol.intro_list_ol
                        li 八字命盤
                        li 五行與十神(直條圖)特性解說。
                        li 人格五特質(雷達圖)特性解說。
                        li 四柱之命理解說。
                        li 流年精闢與問事吉凶。
                        li 流月精闢與問事吉凶。
                        li 流日精闢與問事吉凶。
                    p.intro_txt 問事共有：卦象、運勢、家運、婚姻、戀情、疾病、健康、買賣、財運、事業、建議…29種

            .fix_menu
                a(class="fix_menu_link signin" href="/") 登入
                a(class="fix_menu_link trial" :href="`/register/consent_agree/${u_code}`") 試用
</template>
<script>
    export default {
        name: 'intro',
        data(){
            return {
                u_code:null,
            }
        },
        mounted() {
            this.u_code = this.$route.params.u_code
        }
    }
</script>
<style lang="scss" scoped>
.main {
    margin-top: 2rem;
    margin-bottom: 4rem;
}

.fix_menu {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;

    &_link {
        display: block;
        width: 50%;
        color: white;
        padding: 7px;
        text-align: center;
        font-weight: bold;

        &.signin {
            background: rgb(43,148,100);
            background: linear-gradient(175deg, rgba(43,179,116,1) 0%, rgba(43,148,100,1) 100%);
        }

        &.trial {
            background: rgb(89,200,223);
            background: linear-gradient(175deg, rgba(89,200,223,1) 0%, rgba(31,168,196,1) 100%);
        }
    }
}

.intro {
    &_title {
        color: #33a9c9;
        font-weight: bold;
        margin: 1rem 0;
    }

    &_txt {
        margin-top: 0;
        margin-bottom: 16px;
    }

    &_item {
        margin-bottom: 2rem;
        border: 1px solid #eee;
        padding: 20px;
        border-radius: 6px;
        box-shadow: 0 3px 6px #cbcbcb;
    }

    &_list {
        padding: 0;
        margin: 0 0 16px;
        list-style: none;

        li {
            margin-bottom: 0;
        }
    }

    &_list_ol {
        list-style: disc;
        padding-left: 1.5rem;
    }

    &_img {
        display: block;
        margin: 0 auto;
    }
}

.align-center {
    text-align: center;
        color: #b11868;
}
</style>
